// These are custom user attributes we support within Braze:
export enum BrazeCustomAttributes {
  VISIBLE_IN_TALENT_SCOUT = 'visible_in_talent_scout',
  B21_GENDER = 'b21_gender',
  WORKING_LOCATIONS = 'working_locations',
  ETHNIC_APPEARANCE = 'ethnic_appearance',
  MIN_PLAYABLE_AGE = 'min_playable_age',
  MAX_PLAYABLE_AGE = 'max_playable_age',
}
